module.exports = __webpack_public_path__ + "img/avatar.c1dc74f6.png";